import React from 'react';
import { Check } from 'lucide-react';
import { services } from '../data/site';
export function Services() {
  return <section id="services" className="w-full border-b border-sky-100 bg-white" data-id="element-111" data-mp="1hwp4yf970z3q">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 md:py-28" data-id="element-112" data-mp="1dt9ddxbzdoxw">
        <div className="max-w-xl" data-id="element-113" data-mp="18uy3xnpllgg7">
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#1D4ED8]" data-id="element-114" data-mp="18vr4u81vlbqf">
            Services
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-[#0B2A6B] sm:text-4xl" data-id="element-115" data-mp="13xfr3m8gmh2x">
            One crew, every pane
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600" data-id="element-116" data-mp="u5s5w32hxw9w">
            Homes, storefronts, and everything in between — cleaned by hand and finished
            streak-free.
          </p>
        </div>

        <ul className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="l5wovhm9f71y">
          {services.map(service => <li key={service.title} className="overflow-hidden rounded-sm border border-sky-100 bg-sky-50/50" data-id="element-118" data-mp="g7bnvfz6ojcg">
              <img src={service.image} alt="" className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-119" data-mp="36amw6ldu1brd" />
              <div className="p-6" data-id="element-120" data-mp="2x9ors1zhf289">
                <h3 className="text-lg font-medium text-[#0B2A6B]" data-id="element-121" data-mp="32acrrd5outem">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-122" data-mp="3q0gsncrhsf1x">
                  {service.description}
                </p>
                <ul className="mt-4 space-y-2" data-id="element-123" data-mp="3u10sio3g9wrr">
                  {service.points.map(point => <li key={point} className="flex items-start gap-2 text-sm text-slate-500" data-id="element-124" data-mp="3g17vyc58smbv">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#1D4ED8]" aria-hidden="true" data-id="element-125" data-mp="3l0b1dxp4wukd" />
                      {point}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}